export default "__VITE_ASSET__DqvctIx___"